import React from "react";

import { Box, Column, Columns, Control, Field, Input, Title } from "@allxsmith/bestax-bulma";

function CAPSection(props) {

  return (
    <Box>
      <details>
        <summary><Title>CAP</Title></summary>
      <div>
        <Columns isMultiline>
          <Column>
            <Field>
              <label className="label">CAP Retail</label>
              <Control>
                <Input
                  type="text"
                  name="cap_retail"
                  onChange={props.onChange}
                  value={props.data.cap_retail}
                  required
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">CAP Clean</label>
              <Control>
                <Input
                  type="text"
                  name="cap_clean"
                  onChange={props.onChange}
                  value={props.data.cap_clean}
                  required
                />
              </Control>
            </Field>
          </Column>
          <Column>
          <Field>
            <label className="label">CAP Average</label>
            <Control>
              <Input
                type="text"
                name="cap_average"
                onChange={props.onChange}
                value={props.data.cap_average}
                required
              />
            </Control>
          </Field>
        </Column>
          <Column>
            <Field>
              <label className="label">CAP Below</label>
              <Control>
                <Input
                  type="text"
                  name="cap_below"
                  onChange={props.onChange}
                  value={props.data.cap_below}
                  required
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Date Valued</label>
              <Control>
                <Input
                  type="date"
                  name="cap_date"
                  onChange={props.onChange}
                  value={String(props.data.cap_date)}
                />
              </Control>
            </Field>
          </Column>
        </Columns>
      </div>
      </details>
    </Box>
  );
}

export default CAPSection;
